import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { authSelector } from '@/stores/auth/authSlice'
import { Navigate } from 'react-router-dom'

import storage from '@/utils/storage'
import { UserRole } from '@/features/users/constants'
import { ContributorGroupType } from '@/features/contributorGroups/constants'

const HomePage = () => {
  const params = new URLSearchParams(location.search)

  const { user, isAuthenticated } = useSelector(authSelector)

  if (!isAuthenticated || !user) {
    return <Navigate to={`/auth/login?${params.toString()}`} />
  }

  const redirect = storage.getRedirect()

  if (redirect) {
    // Clear the redirect
    storage.setRedirect('')
    return <Navigate to={`${redirect}`} />
  }

  //Redirect according to the user group

  if (user?.contributorGroup === ContributorGroupType.TEAM_ASSISTANT) {
    return <Navigate to={'/offers/participations'} />
  }
  if (user?.contributorGroup === ContributorGroupType.PROCUREMENT_OFFICER) {
    return <Navigate to={'/offers/sourcingDecisions'} />
  }

  return <Navigate to={`/offers/tasks`} />
}

export default HomePage
